import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "../../lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
        "outline-solid": "border-foreground/20 text-foreground bg-muted/50",
        success:
          "border-transparent bg-green-600 text-white hover:bg-green-600/80",
        warning:
          "border-transparent bg-yellow-600 text-white hover:bg-yellow-600/80",
        info: "border-transparent bg-blue-600 text-white hover:bg-blue-600/80",
        healthy:
          "border-transparent bg-food-healthy-bg text-food-healthy-foreground",
        premium:
          "border-transparent bg-food-premium-bg text-food-premium border-food-premium-accent/30",
        urgency:
          "border-transparent bg-food-urgency-bg text-food-urgency-foreground",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export { Badge, badgeVariants };
